export default "__VITE_ASSET__0g96g6LY__"